import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Config from '../../../Config';
import errorIcon from '../PortalsBlock/images/icon-error/icon-120-error.svg';
import {gtag4} from '../../../utilities/analytics/tracking';

const ChangeHetPayPopUp = (props) => {
  return (
    <Container fluid>
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center'>
          <Image src={errorIcon} alt='התראה' />
        </Row>
        <Row className='justify-content-center'>
          <span className='title-att'>שימו לב</span>
        </Row>
        <Row className='justify-content-center '>
          <span className='popup-title'>נראה שמנוי זה משוייך לארגון {props.isAllowed.newOrgName}</span>
        </Row>
        <Row className='justify-content-center'>
          {props.oldHetPay?.name ? (
            <span className='popup-title'>האם לשנות את בחירתך מ{props.oldHetPay.name} לארגון זה?</span>
          ) : (
            <span className='popup-title'>האם להמשיך עם ארגון זה?</span>
          )}
        </Row>
      </div>

      <Row className='justify-content-center mt-3'>
        <BtnSubmit
          isBusiness
          text={props.btnText}
          onclick={() => {
            gtag4({event: 'SubscriberStatus_WrongNumContinueButtom', button: 'המשך בתהליך', action: 'WrongNumContinueButtom'});
            props.onButtonClick();
          }}
        />
      </Row>
      <Row className='justify-content-center mt-2'>
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            gtag4({
              event: 'SubscriberStatus_WrongNumPersonalAreaButton',
              button: 'חזרה לתפריט הראשי',
              action: 'WrongNumPersonalAreaButton',
            });
            props.setIsShowPopup(false);
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
};

export default ChangeHetPayPopUp;
